import { SvgIcon, SvgIconProps } from '@mui/material';

export const LanguageIcon = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg'>
        <path
          fillRule='evenodd'
          clipRule='evenodd'
          d='M5.96046e-08 9.29302C0.383526 4.09642 4.70174 0 9.9723 0C9.14144 -2.22816e-07 8.40167 0.365902 7.7931 0.925411C7.18758 1.48211 6.67588 2.25924 6.262 3.17786C5.84568 4.10191 5.5223 5.18267 5.30342 6.35554C5.12797 7.29572 5.02119 8.28688 4.9856 9.29302H5.96046e-08ZM0 10.8H4.9856C5.02119 11.8061 5.12797 12.7973 5.30342 13.7375C5.5223 14.9103 5.84568 15.9911 6.262 16.9152C6.67587 17.8338 7.18758 18.6109 7.7931 19.1676C8.40167 19.7271 9.14144 20.093 9.9723 20.093C4.70174 20.093 0.383525 15.9966 0 10.8Z'
          fill='currentColor'
        />
        <path
          d='M9.9723 1.40184C9.69729 1.40184 9.34202 1.5194 8.9289 1.89921C8.51273 2.28183 8.09611 2.88149 7.72801 3.69849C7.36236 4.51008 7.06546 5.48982 6.86114 6.58468C6.70023 7.4469 6.60041 8.36089 6.56538 9.29302H13.3792C13.3442 8.36089 13.2444 7.4469 13.0835 6.58468C12.8791 5.48982 12.5822 4.51009 12.2166 3.6985C11.8485 2.88149 11.4319 2.28183 11.0157 1.89921C10.6026 1.5194 10.2473 1.40184 9.9723 1.40184Z'
          fill='currentColor'
        />
        <path
          d='M6.86114 13.5083C7.06545 14.6032 7.36236 15.5829 7.72801 16.3945C8.09611 17.2115 8.51273 17.8112 8.9289 18.1938C9.34202 18.5736 9.69729 18.6912 9.9723 18.6912C10.2473 18.6912 10.6026 18.5736 11.0157 18.1938C11.4319 17.8112 11.8485 17.2115 12.2166 16.3945C12.5822 15.5829 12.8791 14.6032 13.0835 13.5083C13.2444 12.6461 13.3442 11.7321 13.3792 10.8H6.56538C6.60041 11.7321 6.70023 12.6461 6.86114 13.5083Z'
          fill='currentColor'
        />
        <path
          d='M9.9723 0C10.8032 2.22816e-07 11.5429 0.365903 12.1515 0.925412C12.757 1.48212 13.2687 2.25924 13.6826 3.17787C14.0989 4.10191 14.4223 5.18268 14.6412 6.35554C14.8166 7.29572 14.9234 8.28688 14.959 9.29302H19.9446C19.5611 4.09642 15.2429 0 9.9723 0Z'
          fill='currentColor'
        />
        <path
          d='M14.6412 13.7375C14.4223 14.9103 14.0989 15.9911 13.6826 16.9152C13.2687 17.8338 12.757 18.6109 12.1515 19.1676C11.5429 19.7271 10.8032 20.093 9.9723 20.093C15.2429 20.093 19.5611 15.9966 19.9446 10.8H14.959C14.9234 11.8061 14.8166 12.7973 14.6412 13.7375Z'
          fill='currentColor'
        />
      </svg>
    </SvgIcon>
  );
};
